module.exports = __webpack_public_path__ + "static/media/pudo-logo-3.f49a5ad8.png";